import { useMemo } from 'react';

import useStateWhileMounted from 'hooks/useStateWhileMounted.hook';

const ALWAYS = Symbol('always reset the state');
const DIFFERENT = Symbol('reset state if different from before');
const NEVER = Symbol('never reset the state');
const NIL = Symbol('reset state on null and undefined');
const NULL = Symbol('reset state on null');
const UNDEFINED = Symbol('reset state on undefined');

const useResettingState = (init, mode) => {
  const [val, set] = useStateWhileMounted();

  const m = mode || UNDEFINED;

  return useMemo(
    () => {
      if (m === ALWAYS) return [init, set];
      if (m === NEVER) return [val, set];

      if ((m === UNDEFINED || m === NIL) && val === void 1) return [init, set];
      if ((m === NULL || m === NIL) && val === null) return [init, set];
      if (m === DIFFERENT && init !== val) return [init, set];

      return [val, set];
    },
    [m, val, set, init],
  );
};

// NOTE: this way they will be tied to the hook and accessed as useResettingState.ON_...
Object.assign(useResettingState, {
  ALWAYS,
  DIFFERENT,
  NEVER,
  NIL,
  NULL,
  UNDEFINED,
});

// noinspection JSUnusedGlobalSymbols
export default useResettingState;
